import { TemporalityEnum } from "common/enums/TemporalityEnum";
import { Posology, PosologyType } from "./posology.model";
import { MedicationEntryDTO } from "api/medication.api";
import { StatusTypeEnum } from "common/enums/StatusTypeEnum";
import { MedicationStopType } from "model/medication-stop.model";

export interface MedicationEntryType {
  readonly id: number;
  readonly status: StatusTypeEnum;
  readonly prescriptionStatus: MedicationEntryPrescriptionStatusEnum;
  readonly freeTextContent: string;
  readonly temporality?: TemporalityEnum;
  readonly posology: PosologyType;
  readonly subContactsIDs: Array<number>;
  readonly medicationStops?: Array<MedicationStopType>;
  readonly dto?: MedicationEntryDTO;
  readonly dtoOrigin?: MedicationEntryDTO;
}

export enum MedicationEntryPrescriptionStatusEnum {
  DEFAULT,
  NEW,
  EDITED,
  REPEAT,
  PREFILL
}

export class MedicationEntry implements MedicationEntryType {
  readonly id: number;
  readonly status: StatusTypeEnum;
  readonly prescriptionStatus: MedicationEntryPrescriptionStatusEnum;
  readonly freeTextContent: string;
  readonly temporality?: TemporalityEnum;
  readonly posology: PosologyType;
  readonly subContactsIDs: Array<number>;
  readonly medicationStops?: Array<MedicationStopType>;
  readonly dto?: MedicationEntryDTO;
  readonly dtoOrigin?: MedicationEntryDTO;

  constructor(data?: MedicationEntryType) {
    this.id = -1;
    this.status = StatusTypeEnum.ACTIVE;
    this.prescriptionStatus = MedicationEntryPrescriptionStatusEnum.DEFAULT;
    this.freeTextContent = "";
    this.posology = new Posology();
    this.subContactsIDs = [];
    if (data) {
      Object.assign(this, data);
      data.posology &&
        Object.assign(this.posology, new Posology(data.posology));
    }
  }
}

export const sortMedicationEntries = (
  medicationEntries: Array<MedicationEntry>
): Array<MedicationEntry> => {
  medicationEntries.sort((a, b) =>
    a.freeTextContent.localeCompare(b.freeTextContent)
  );
  return medicationEntries;
};
